import { useCallback } from 'react';
import { DataGridVirtualizationProps } from '../types/data-grid-virtualization-props.type';

export const useDataGridVirtualization = ({
  currentRowCount,
  totalRowCount,
  pageSize,
  isFetching,
  hasNextPage,
  fetchNextPage,
}: DataGridVirtualizationProps) => {
  const nextPageCount = Math.min(totalRowCount - currentRowCount, pageSize);
  /**
   * MUI Data Grid's rowCount determines how many placeholder rows to generate as users scroll down to get more data.
   * Since the total number of results can get into the thousands, setting rowCount only up to the next page
   * will prevent users from possibly fetching too many rows at once when they scroll down.
   */
  const rowCount =
    totalRowCount > currentRowCount ? currentRowCount + nextPageCount : currentRowCount;

  const fetchMoreRows = useCallback(
    ({ lastRowToRender }) => {
      const hasNotRenderedLastRow = lastRowToRender < currentRowCount - 1;
      if (hasNotRenderedLastRow || isFetching || !hasNextPage) {
        return;
      }
      fetchNextPage();
    },
    [fetchNextPage, isFetching, currentRowCount, hasNextPage],
  );
  return { rowCount, fetchMoreRows };
};
